import { axiosSecuredInstance } from "configurations/axiosConfig";
import * as ApiModel from "entities/ApiModel";
import {
  ActionResult,
} from "entities/UIModel";
// import { hasErrorOnSingleProductAction } from "pages/file/utils/helper";
import {
  StoreActionApi,
  createHook,
  createStore,
} from "react-sweet-state";
import { ActionResultStatus, ProductType  } from "utils/data/enum";
interface State {
  isActionInProgress: boolean;
  error: any;
}
type StoreApi = StoreActionApi<State>;

const initialState: State = {
  isActionInProgress: false,
  error: null,
};

const actions = {
  titleSearchResend:
    (scfile: ApiModel.SCFile, orderId: number, tpsName: string, integrationKey: string) =>
      async ({
        setState,
      }: StoreApi): Promise<ActionResult> => {
        try {
          setState({ isActionInProgress: true, error: null });
          const { data, headers } = await axiosSecuredInstance.post(
            `/tps/TitleSearchResend?productType=${ProductType.TitleSearch}&orderId=${orderId}&tpsSource=${tpsName}`,
            scfile
          );

          // rlo 8/11/2025 - DO Not check product error message for Resend to TPS
          // const hasError = hasErrorOnSingleProductAction(
          //   data,
          //   ProductAction.TitleSearchResendToTPS,
          //   ProductType.TitleSearch,
          //   integrationKey,
          // );
            
          setState({ isActionInProgress: false });

          return {
            status: ActionResultStatus.Success, // hasError ? ActionResultStatus.Failed : ActionResultStatus.Success,
            headers: headers,
            scfile: data,
          };
        } catch (error) {
          setState({ error });
          return {
            status: ActionResultStatus.Failed,
            error: error,
          };        }
        finally {
          setState({ isActionInProgress: false });
        }
      },

};

const Store = createStore<State, typeof actions>({
  initialState,
  actions,
  name: "tps",
});

const hook = createHook(Store);
export const useTPS = () => {
  return hook();
};
